import {NgModule} from '@angular/core';
import {ProfessionalLiabilityService} from './professional-liability.service';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    providers: [ProfessionalLiabilityService]
})
export class ProfessionalLiabilityModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/liability/professional-liability.module.ts